module.exports = __webpack_public_path__ + "static/media/zenith.a72c4854.svg";